export const VAT_POST_START = "VAT_POST_START";
export const VAT_POST_SUCCESS = "VAT_POST_SUCCESS";
export const VAT_POST_FAILURE = "VAT_POST_FAILURE";
export const ALL_VAT_GET_FETCH_FAILURE = "ALL_VAT_GET_FETCH_FAILURE";
export const ALL_VAT_GET_FETCH_START = "ALL_VAT_GET_FETCH_START";
export const ALL_VAT_GET_FETCH_SUCCESS = "ALL_VAT_GET_FETCH_SUCCESS";